<template>
  <div class="admin-page">
    <el-card class="admin-heading glass-card" shadow="never">
      <i class="el-icon-setting"></i>
      <div><small>WEBSITE ADMINISTRATION</small><h1>网站管理</h1></div>
    </el-card>
    <div v-if="ready" class="admin-layout">
      <el-card class="admin-menu glass-card" shadow="never">
        <div class="menu-caption">管理菜单</div>
        <el-menu :default-active="active" @select="active = $event">
          <el-menu-item index="users"><i class="el-icon-user"></i>用户管理</el-menu-item>
          <el-menu-item index="makers"><i class="el-icon-office-building"></i>社团管理</el-menu-item>
          <el-menu-item index="works"><i class="el-icon-collection"></i>作品管理</el-menu-item>
          <el-menu-item index="backgrounds"><i class="el-icon-picture-outline"></i>背景标签</el-menu-item>
          <el-menu-item index="labs"><i class="el-icon-magic-stick"></i>实验室管理</el-menu-item>
        </el-menu>
      </el-card>
      <el-card class="admin-detail glass-card" shadow="never">
        <div class="detail-heading"><div><small>{{ headings[active].eyebrow }}</small><h2>{{ headings[active].title }}</h2></div></div>
        <div class="detail-body">
          <user-card-panel v-if="active === 'users'"></user-card-panel>
          <bg-tag v-if="active === 'backgrounds'"></bg-tag>
          <admin-catalog v-if="active === 'makers' || active === 'works'" :kind="active"></admin-catalog>
          <admin-lab v-if="active === 'labs'"></admin-lab>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import UserCardPanel from '@/components/UserCardPanel.vue'
import BgTag from '@/components/BgTag.vue'
import AdminCatalog from '@/components/AdminCatalog.vue'
import AdminLab from '@/components/AdminLab.vue'
export default {
  name: 'AdminPanel',
  components: { UserCardPanel, BgTag, AdminCatalog, AdminLab },
  data() {
    return { active: 'users', ready: false, headings: {
      users: { eyebrow: 'USERS', title: '用户管理' },
      makers: { eyebrow: 'CIRCLE LINKS', title: '社团外部站点' },
      works: { eyebrow: 'WORK METADATA', title: '作品管理' },
      backgrounds: { eyebrow: 'BACKGROUND TAGS', title: '背景标签' },
      labs: { eyebrow: 'LABORATORY', title: '实验室管理' }
    } }
  },
  async created() {
    const token = localStorage.getItem('token')
    if (!token) { this.$router.replace('/login'); return }
    try {
      const response = await axios.post('/api/getRole', {}, { headers: { Authorization: 'Bearer ' + token } })
      const account = response.data.data
      if (!account || !account.id) throw new Error('登录已过期，请重新登录')
      if (!String(account.role || '').includes('管理员')) throw new Error('当前账号没有网站管理权限')
      this.ready = true
    } catch (error) {
      const denied = error.message === '当前账号没有网站管理权限'
      this.$message.error(denied ? error.message : '登录已过期或后端暂不可用，请重新登录')
      this.$router.replace(denied ? '/' : '/login')
    }
  }
}
</script>

<style scoped>
.admin-page { display:flex; flex-direction:column; gap:10px; height:100%; min-height:0; color:#303133; text-align:left; }
.glass-card { background:rgba(255,255,255,.66); border:1px solid rgba(220,223,230,.8); border-radius:16px; backdrop-filter:blur(18px); -webkit-backdrop-filter:blur(18px); }
.admin-heading { flex:none; }
.admin-heading >>> .el-card__body { display:flex; align-items:center; gap:14px; padding:16px 20px; }
.admin-heading i { display:grid; place-items:center; width:44px; height:44px; border-radius:12px; color:#409eff; background:rgba(64,158,255,.12); font-size:22px; }
small { color:#409eff; font-size:11px; font-weight:700; letter-spacing:.13em; }
h1,h2 { margin:3px 0 0; line-height:1.2; } h1 { font-size:23px; } h2 { font-size:19px; }
.admin-layout { display:grid; grid-template-columns:218px minmax(0,1fr); gap:10px; flex:1; min-height:0; }
.admin-menu,.admin-detail { min-height:0; overflow:hidden; }
.admin-menu >>> .el-card__body { padding:12px 8px; }
.menu-caption { padding:4px 12px 9px; color:#909399; font-size:12px; }
.admin-menu .el-menu { background:transparent; border:0; }
.admin-menu .el-menu-item { height:42px; line-height:42px; margin-bottom:4px; border-radius:8px; }
.admin-menu .el-menu-item.is-active { background:rgba(64,158,255,.13); }
.admin-detail >>> .el-card__body { height:100%; min-height:0; box-sizing:border-box; display:flex; flex-direction:column; padding:0; }
.detail-heading { flex:none; padding:17px 20px; border-bottom:1px solid rgba(220,223,230,.7); }
.detail-body { flex:1; min-height:0; overflow:auto; padding:18px 20px; box-sizing:border-box; }
@media (max-width:767px) {
  .admin-page { height:auto; min-height:calc(100dvh - 110px); }
  .admin-layout { display:block; }
  .admin-menu { margin-bottom:10px; }
  .admin-menu .el-menu { display:flex; overflow-x:auto; }
  .admin-menu .el-menu-item { flex:none; padding:0 12px; }
  .admin-detail { min-height:70vh; }
}
</style>
